import * as React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import TextStyles from '../theme/text';
import clsx from 'clsx';

interface Props {
  /** The table rows */
  children: React.ReactNode;
  /** className for extra styles */
  className?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    height: 27,
    '& td': {
      ...TextStyles.caption,
      paddingTop: 25,
      paddingRight: 20,
      paddingBottom: 11,
      '&:first-child': {
        paddingLeft: 38
      }
    }
  }
}));

/**
 * Table Body, container for table rows
 */
const TableBody = ({ children, className }: Props) => {
  const classes = useStyles();
  return <tbody className={clsx(classes.root, className)}>{children}</tbody>;
};

export default TableBody;
